
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import { RevRadio } from '@ds/components/Radio'

import { trackClick } from '@tracking/events'

import { TRACKING_ZONE } from '../Page/constants'

import { RATE_SORT_OPTIONS, RATE_SORT_TYPE } from './RateSort.constants'
import translations from './RateSort.translations'

export default {
  components: {
    RevList,
    RevListItem,
    RevRadio,
    RevInputSelect,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: RATE_SORT_TYPE.RADIO,
      validator: (type) => Object.values(RATE_SORT_TYPE).includes(type),
    },
  },
  computed: {
    translations: () => translations,
    isTypeSelect() {
      return this.type === RATE_SORT_TYPE.SELECT
    },
    selectedSort: {
      get() {
        return this.$route.query.order_by || RATE_SORT_OPTIONS.RELEVANCE
      },
      set(sort) {
        trackClick({
          pageType: this.$route.name,
          zone: TRACKING_ZONE,
          name: `review_star_sort_${sort}`,
        })

        this.$navigation.push({
          type: 'internal',
          query: { ...this.$route.query, order_by: sort },
        })
      },
    },
    sortOptions() {
      return [
        {
          label: this.$t(translations.relevance),
          value: RATE_SORT_OPTIONS.RELEVANCE,
        },
        {
          label: this.$t(translations.recentReviews),
          value: RATE_SORT_OPTIONS.RECENT,
        },
        {
          label: this.$t(translations.rateDescending),
          value: RATE_SORT_OPTIONS.HIGHEST,
        },
        {
          label: this.$t(translations.rateAscending),
          value: RATE_SORT_OPTIONS.LOWEST,
        },
      ]
    },
  },
}
